const filterNodes = {
  quickShopModal: document.querySelector('quick-shop'),
  parent: document.querySelector('[data-id="collectionFilters"]'),
  gridsContainer: document.getElementById('products-listing'),
  collectionBanner: document.querySelector('[data-collectionBanner]'),
  subCollectionLinks: Array.from(document.getElementsByClassName('subcollection-links')),
  activeFilters: document.querySelector('[data-activeFilters]'),
  drawerFooter: document.querySelector('[data-filterFooter]'),
  openDrawerBtns: document.querySelectorAll('[data-openFilterDrawer]'),
  paginationParent: document.querySelector('[data-paginationParent]'),
  closeDrawer: document.querySelector('[data-closeDrawer]')
}

class CollectionFilters {
  constructor() {
    this.filterForm = filterNodes.parent.querySelector('form') || null;
    filterNodes.parent.addEventListener('keyup', (event) => {
      if(event.code && event.code.toUpperCase() === 'ESCAPE') filterNodes.closeDrawer.dispatchEvent(new Event('click'));
    });

    this.debouncedOnSubmit = Utility.debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    if(this.filterForm){
      this.filterForm.addEventListener('input', (evt)=>{
        if((evt && evt.target.type == 'range') || window.innerWidth < 992) return false;
        this.debouncedOnSubmit(evt);
      });
      this.filterForm.addEventListener('submit', this.debouncedOnSubmit.bind(this));
     
      // window.addEventListener('popstate', this.onHistoryChange.bind(this));
    }
    
    this.bindEvents();
    this.dynamicEleEvents();
    this.init();
  }

  init() {
    
    document.querySelector('[data-haslink]')?.addEventListener('click', (evt) => {
      evt.stopPropagation();
      evt.target.closest('li').classList.toggle('open');
    });
  }

  /**
   * bind dclick and keyup event to Cart Icons
   * bind keyUp event to Cart drawer component
   * bind Other inside element events
   *
  */
  bindEvents() {
    /** There are two open drawer buttons, one for Open filter drawer other for open sortby drawer **/
    // if(filterNodes.openDrawerBtns.length > 0){
    //   filterNodes.openDrawerBtns.forEach(button => button.addEventListener('click', this.toggleFilterDrawer.bind(this)));
    // }
    // filterNodes.closeDrawer.addEventListener('click', this.toggleFilterDrawer.bind(this));

    let sortby_desktop = document.querySelectorAll('[data-sortByDesktop] .sortby_options');
    sortby_desktop.forEach(input => input.addEventListener('change', this.updateSortBy.bind(this)));

    let paginateByValues = document.querySelectorAll('[data-custom-pagination] [name="paginateBy"]');
    paginateByValues.forEach(input => input.addEventListener('change', this.paginateProductsBy.bind(this)));

    /** Only for horizontal filters - Close filters when clicked outside container **/
    const filterType = filterNodes.parent.dataset.filtertype;
    if(filterType == 'horizontal-filters'){
      document.body.addEventListener('click', (_event)=>{
        const openFilters = document.querySelectorAll('.filter__container.open');
        openFilters.forEach((target) => {
          target.querySelector('.tab_toggle').click();
        })
      });
  
      const filterContainers = document.querySelectorAll('.filter__container');
      filterContainers.forEach((target) => {
        target.addEventListener('click', (event)=>{
          event.stopPropagation();
        });
      });
    }
  }

  dynamicEleEvents() {
    /** Toggle each filter block container containing values for dropdown effect **/
    filterNodes.subCollectionLinks = Array.from(document.getElementsByClassName('subcollection-links'));
    filterNodes.subCollectionLinks.forEach(link => link.addEventListener('click', this._manageSubCollections.bind(this)));

    if(filterNodes.quickShopModal && typeof filterNodes.quickShopModal.updateEvents == 'function'){ 
      filterNodes.quickShopModal.updateEvents(); 
    }

    const applyBtn = filterNodes.parent.querySelector('[data-applyFilters]');
    if(applyBtn){
      applyBtn.addEventListener('click', () => {
        const searchParams = this._createQueryString(this.filterForm)
        this.renderPage(searchParams);
      });
    }

    const paginationLinks = document.querySelectorAll('[data-pagelinks]');
    paginationLinks.forEach(link => link.addEventListener('click', this._managePagination.bind(this)));

    // this.colorOptionsStyling();
    this.bindActiveFilterButtonEvents();
  }

  /**
   * Collection filter form Input event
   * @param {event} event Event Instance
   */
  onSubmitHandler(event) {
    event.preventDefault();
    const searchParams = this._createQueryString(this.filterForm)
    this.renderPage(searchParams);
  }

  /**
   * click event To Remove current selections
   * @param {element} form Collection page filter form
   */
  _createQueryString(form){
    const formData = new FormData(form);
    if(form.querySelector('[name="filter.v.price.gte"]')){
      const priceGTE = form.querySelector('[name="filter.v.price.gte"]').min;
      const priceLTE = form.querySelector('[name="filter.v.price.lte"]').max;

      if(parseInt(formData.get('filter.v.price.gte')) == parseInt(priceGTE)){
        formData.delete('filter.v.price.gte');
      }
      if(parseInt(formData.get('filter.v.price.lte')) == parseInt(priceLTE)){
        formData.delete('filter.v.price.lte');
      }
    }
    return new URLSearchParams(Array.from(formData)).toString();
  }

  /**
   * 
   * @param {String} searchParams Query Parameters
   * @param {String} updateURLHash true/false
  */
  renderPage(searchParams, updateURLHash = true) {
    filterNodes.gridsContainer.classList.add('loading');

    const url = `${window.location.pathname}?${searchParams}`;
    this.renderGridFromFetch(url, 'filter');

    if (updateURLHash) this.updateURLHash(searchParams);
  }

  /**
   * Add background color in label of Color options
   */
  colorOptionsStyling(){
    const colorSwatchContainer = filterNodes.parent.querySelector('[data-colorFilter]');
    if(colorSwatchContainer){
      const colorSwatches = colorSwatchContainer.querySelectorAll('.color-options');
      colorSwatches.forEach(swatch => {
        let colorHandle = swatch.querySelector('input[type="checkbox"]').dataset.handle;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        swatch.querySelector('.option-label').setAttribute('style', swatchStyle);
      });
    }
  }

  /**
   * click event To Remove current selections
   * @param {event} event Event Instance
   */
   onActiveFilterClick(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    let URLString = new URL(event.currentTarget.href).searchParams.toString();
    if(URLString != null) this.renderPage(URLString);
  }

   /**
   * Update Window URL as per active filters
   * @param {event} event Event Instance
   */
  onHistoryChange(event) {
    const searchParams = event.state?.searchParams || '';
    this.renderPage(searchParams, false);
  }

  /**
   * 
   * @param {String} url URL for fetching results
   * @param {String} type filter / pagination / sub_collection
   */
  renderGridFromFetch(url, type) {
    if(!url) return;

    let sectionID = document.getElementById('products-listing').dataset.id;
    if(type == 'sub_collection'){
      url += `&sections=${sectionID},template-collection-banner`;
    }else{
      url += `&sections=${sectionID}`;
    }
   
    fetch(url)
      .then(response => response.json())
      .then((response) => {
        let gridHTML = response[sectionID];
        let bannerHTML = response['template-collection-banner'];
        this.renderProductGrid(type, gridHTML, bannerHTML);
      });
  }

  /**
   * 
   * @param {HTMlResponse} html 
   * @param {String} type filter / pagination / sub_collection
   */
  renderProductGrid(type, grid, banner) {
    const collectionParent = new DOMParser().parseFromString(grid, 'text/html');
    let paginationType = (filterNodes.paginationParent) ? filterNodes.paginationParent.dataset.type : 'numbers';

    if(type == 'pagination' && paginationType == 'loadmore'){
      let productGrids = filterNodes.gridsContainer.querySelector('#product-grids');
      productGrids.insertAdjacentHTML('beforeend', collectionParent.querySelector('#product-grids').innerHTML);

      let loadMoreBtn = document.getElementById('load-more');
      if(collectionParent.getElementById('load-more') && loadMoreBtn){   
        loadMoreBtn.parentNode.replaceChild(collectionParent.getElementById('load-more'), loadMoreBtn); 
      }else if(loadMoreBtn){
        loadMoreBtn.remove();
      }
    }else{
      const gridsHTML = collectionParent.getElementById('products-listing').innerHTML;
      filterNodes.gridsContainer.innerHTML = gridsHTML;
    }
    
    const filterPanels = collectionParent.querySelectorAll('#CollectionFiltersForm .filter__container');
    document.querySelectorAll('#CollectionFiltersForm .filter__container').forEach(panel => panel.classList.add('d-none'));
    filterPanels.forEach((panel)=> {
      let filterBlock = document.querySelector('.filter__container[data-index="'+panel.dataset.index+'"]');
      if(filterBlock){
        filterBlock.querySelector('.filter__block').innerHTML = panel.querySelector('.filter__block').innerHTML;
        filterBlock.classList.remove('d-none');
      }
    });

    const activeFilters = collectionParent.querySelector('[data-activeFilters]');
    if(activeFilters) filterNodes.activeFilters.innerHTML = activeFilters.innerHTML;
    this.dynamicEleEvents();

    /******** Change banner on subcollection **********/
    if(type == 'sub_collection' && filterNodes.collectionBanner && banner){
      const bannerNode = new DOMParser().parseFromString(banner, 'text/html');
      let bannerHTML = bannerNode.querySelector('[data-collectionBanner]').innerHTML;
      filterNodes.collectionBanner.innerHTML = bannerHTML;
    }

    let drawerOpen = filterNodes.parent.classList.contains('filter-active');
    if(drawerOpen) filterNodes.closeDrawer.dispatchEvent(new Event('click'));
  }

  /**
   * Re-Binding events on active filters after ajax request
   */
  bindActiveFilterButtonEvents() {
    let removeActiveFilters = Array.from(document.getElementsByClassName('filter-option-clear'));
    removeActiveFilters.forEach((element) => {
      element.addEventListener('click', this.onActiveFilterClick.bind(this), { once: true });
    });
  }

  /**
   * Update the url
   * @param {String} searchParams 
   */
  updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  /**
   * 
   * @param {event} event 
   */
  updateSortBy(event){
    let currentEle = event.currentTarget;
    let targetOpt = document.querySelector(`.template-collection-grid input[name="sort_by"][value="${currentEle.value}"]`);
    if(targetOpt){
      targetOpt.checked = true;
      const searchParams = `sort_by=${currentEle.value}`;
      this.renderPage(searchParams);
    }
  }

  /**
   * 
   * @param {event} event 
   */
  paginateProductsBy(event){
    event.preventDefault();
    let currentValue = document.querySelector('[data-custom-pagination] [name="paginateBy"]:checked').value;
    let requestData = { 
      attributes: { 'products_per_page': currentValue } 
    };

    fetch("/cart/update", {
    method: "POST",
    headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
    },
    body: JSON.stringify(requestData),
    }).then((data) =>{
      const searchParams = this._createQueryString(this.filterForm);
      const url = `${window.location.pathname}?${searchParams}`;
      this.renderGridFromFetch(url, 'pagination');
    });
  }

  /**
   * 
   * @param {event} event 
   */
  _manageSubCollections(event){
    event.preventDefault();
    const _this =  event.currentTarget;
    const queryString = this._createQueryString(this.filterForm);
    let collURL = _this.href + '?' + queryString;
  
    this.renderGridFromFetch(collURL, 'sub_collection');

    setTimeout(() => {
      filterNodes.subCollectionLinks.forEach(link => link.classList.remove('active'));
      _this.classList.add('active');
      history.pushState({}, '', collURL);
    }, 500);
  }

  /**
   * 
   * @param {event} event 
   */
  _managePagination(event){
    event.preventDefault();
    const el = event.currentTarget;
    const paginationUrl = el.href || el.dataset.url || '';
    this.renderGridFromFetch(paginationUrl, 'pagination');

    const paginationType = el.closest('[data-paginationparent]')?.dataset?.type;
    if (paginationType !== 'loadmore') {
      setTimeout(() => {
        history.pushState({}, '', paginationUrl);
      }, 500);
    }
  }

}
typeof CollectionFilters !== 'undefined' && new CollectionFilters();
